import { createFileRoute } from "@tanstack/react-router";
import type { ClientHomePlanBaseData } from "api-types/homePlans/homePlanResponses";
import Showroom from "lib/components/builders/communities/plans/showroom/Showroom";
import { getHomePlanBaseDataURL } from "lib/endpointHelpers";
import { useFetch } from "lib/fetcher";
import { useAppRouterParams } from "lib/routeHelpers";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../../../../components/withAuthentication";

function InternalHomePlanOverviewPage() {
  const { builderId, homePlanId } = useAppRouterParams();

  const { data, loading } = useFetch<ClientHomePlanBaseData>(
    builderId && homePlanId ? getHomePlanBaseDataURL({ builderId, homePlanId }) : "",
    [builderId, homePlanId],
  );

  return (
    <>
      <Head>
        <title>{getPageTitle(data?.homePlan.planSetId)}</title>
        <meta name="robots" content="noindex" />
      </Head>
      {data && !loading && (
        <Showroom
          builder={data?.builder}
          location={data?.community}
          lot={data?.lot}
          masterPlan={data?.masterPlan}
          locationPlan={data?.communityPlan}
          homePlan={data?.homePlan}
          lotDiscounts={data?.lotDiscounts}
          homePlanDiscounts={data?.homePlanDiscounts}
          overviewOnly
          publicConfig={false}
          elevationOverrides={data?.elevationOverrides}
        />
      )}
    </>
  );
}

export const Route = createFileRoute("/builders/$builder_id/home-plans/$home_plan_id/overview-internal")({
  component: withAuthentication(InternalHomePlanOverviewPage, { permissions: ["VIEW_HOME_PLANS"] }),
});
